<template>
  <modal height="auto" :width="width" name="basket-modal" transition="pop-out" @closed="beforeClose" @before-open="beforeOpen">
    <div class="basket-modal">
      <div class="close__button" @click="$modal.hide('basket-modal')">X</div>
      <h1 class="basket-modal__title" v-if="data">{{ data.title }}</h1>

      <div class="basket-modal__body">
        <div class="mr-5">
          <label @click="forOther = false">
            <input type="radio" name="donate" value="own" v-model="picked" />
            Kendi Adıma
            <div class="control__indicator"></div>
          </label>
        </div>
        <div>
          <label @click="forOther = true">
            <input type="radio" name="donate" value="other" v-model="picked" />
            Başkasının Adına
            <div class="control__indicator"></div>
          </label>
        </div>
      </div>

      <div v-if="forOther" class="for_other_donator mt-5">
        <input class="mb-3 basket-modal__input" type="text" v-model="other_name" placeholder="Ad Soyad" />
        <the-mask
          class="basket-modal__input"
          :mask="['+90 (###) ### ## ##']"
          placeholder="Cep Telefonu"
          v-model="other_phone"
          required
        />
      </div>

      <div class="basket-modal__children" v-if="children.length">
        <p>BİR SEÇİM YAPINIZ</p>
        <select v-model="selected" class="form-control" @change="selectChild">
          <option disabled value="">Bir Seçim Yapın</option>
          <option :value="idx" v-for="(child, idx) in children" :key="child.id">
            {{ child.title.toLocaleUpperCase("tr") + "-" + child.price }} TL
          </option>
        </select>
      </div>

      <div class="basket-modal__footer">
        <div class="basket-modal__input-box flex-fill">
          <input type="text" class="input" v-model="price" :disabled="data.changeable == 0" placeholder="ücret" />
          <span>₺</span>
        </div>
        <button @click="addToCart" class="button button__red flex-fill">BAĞIŞ YAP</button>
      </div>
      <div v-if="data.category && data.category.id == 3" class="basket-modal-proxy">
        <div class="basket-modal-proxy-check"></div>
        <p>İsmailağa görevlisini vekil tayin ettim</p>
      </div>
      <div v-if="!children.length && (data && data.changeable == 0 && data.category.id !== 3)" class="basket-modal__quantity">
        <button @click="quantity -= 1">-</button>
        <input v-model="quantity" type="text" />
        <span>Adet</span>
        <button @click="quantity += 1">+</button>
      </div>

      <p v-if="!children.length && (data.changeable == 0 && data.category.id !== 3)" class="basket-modal__quantity--title">
        Toplam: {{ price }} x {{ quantity }} = {{ price * quantity }} ₺
      </p>
    </div>
  </modal>
</template>

<script>
import { mapActions } from 'vuex'
import { TheMask } from 'vue-the-mask'
import Swal from 'sweetalert2'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: {},
      name: '',
      price: 0,
      phone: '',
      picked: '',
      width: 450,
      tempImg: '',
      quantity: 1,
      selected: 0,
      children: [],
      other_name: '',
      other_phone: '',
      forOther: false
    }
  },
  components: {
    TheMask
  },
  methods: {
    ...mapActions(['pushToCart', 'fetchBasketFromLocal']),
    selectChild() {
      const child = this.children[this.selected]
      this.data = child
      this.price = child.price
    },
    beforeOpen(event) {
      this.selected = 0
      this.picked = 'own'
      this.other_name = null
      this.other_phone = null
      this.quantity = 1
      this.children = event.params.data.sub_products
      this.tempImg = event.params.data.image // for sub products
      this.data = this.children.length ? this.children[0] : event.params.data
      this.price = this.data.price
    },
    beforeClose() {
      this.data = {}
      this.$store.dispatch('toggleBasketModal', {
        isOpen: false
      })
    },
    addToCart() {
      const minPrice = this.data.min_price ? this.data.min_price : 1
      if (this.price < minPrice) {
        Swal.fire({
          title: `Bağış tutarı minumum ${minPrice} TL olmalıdır.`,
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Tamam'
        })
      } else {
        this.data.quantity = this.quantity
        this.data.donator_name = this.name
        this.data.phone = this.phone
        this.data.other_name = this.other_name
        this.data.other_phone = this.other_phone
        this.data.quantity = this.quantity
        this.data.price = this.price
        this.data.image = this.tempImg
        this.pushToCart(this.data)
        this.$modal.hide('basket-modal')
        setTimeout(() => {
          this.$root.$emit('open-nav', true)
        }, 300)
      }
    }
  },
  created() {
    this.width = Math.min(window.innerWidth - 20, 500)
  },
  watch: {
    forOther(value) {
      if (value) {
        this.other_name = null
        this.other_phone = null
      }
    },
    quantity() {
      if (this.quantity < 1) this.quantity = 1
    },
    price() {
      if (this.price < 0) this.price = 5
    },
    show(newVal) {
      if (newVal === true) {
        this.$modal.show('basket-modal')
        this.price = this.data.price
      } else {
        this.$modal.hide('basket-modal')
      }
    },
    picked() {
      if (this.picked === 'other') {
        this.forOther = true
      } else this.forOther = false
    }
  },
  destroyed() {
    this.$store.dispatch('toggleBasketModal', {
      isOpen: false
    })
  }
}
</script>

<style lang="scss">
.basket-modal-proxy {
  color: #ffffff;
  text-align: center;
  padding-top: 30px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    margin: 0;
  }

  &-check {
    background-color: #d90c00;
    height: 20px;
    width: 20px;
    margin-right: 15px;
    border-radius: 50%;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background-color: #fff;
      height: 10px;
      width: 10px;
      border-radius: 50%;
    }
  }
}
</style>
